import { mapActions } from "vuex";

export const clockMixins = {
  data() {
    return {
      formData: {
        id: null,
        name: "",
        description: "",
        audioSsmlText: "",
        displayDescription: "",
        speechRate: 1.0,
        material: "",
        materialUrl: "",
      },
      rules: {
        name: [
          {
            required: true,
            message: "请输入",
            trigger: ["blur", "change"],
          },
        ],
        displayDescription: [
          {
            required: true,
            message: "请输入",
            trigger: ["blur", "change"],
          },
          {
            pattern: /^[\s\S]{0,160}$/,
            message: "不得超过160字",
            trigger: ["blur", "change"],
          },
        ],
      },
    };
  },

  methods: {
    ...mapActions("pluginCenter", ["saveKnowledge"]),
    clearForm() {
      Object.keys(this.formData).map((key) => {
        this.formData[key] = "";
      });
      this.formData.id = null;
      this.formData.speechRate = 1.0;
    },
    async handleConfirm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          if (
            this.formData.materialUrl &&
            this.inputValArr.length < 1 &&
            this.formData.audioSsmlText !== ""
          ) {
            this.$confirm(
              "你已对音频文字进行了删除操作,请选择是否要同步清除音频!",
              "提示",
              {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
                closeOnClickModal: false,
              }
            )
              .then(async () => {
                this.formData.description = "";
                this.formData.audioSsmlText = "";
                this.formData.materialUrl = "";
                this.formData.material = "";
                this.formData.speechRate = 1.0;
              })
              .catch(() => {
                this.formData.audioSsmlText = "";
              });
            return;
          }
          let newAudioSsmlText = this.creatSsmlText(this.inputValArr);
          if (
            newAudioSsmlText !== this.formData.audioSsmlText &&
            this.inputValArr.length > 0
          ) {
            this.$confirm(
              "你已对音频文字进行了修改,请确认是否重新生成音频!",
              "提示",
              {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
                closeOnClickModal: false,
              }
            )
              .then(async () => {
                await this.handleCreatAudio();
              })
              .catch(() => {
                this.formData.audioSsmlText = newAudioSsmlText;
              });
            return;
          }
          newAudioSsmlText = null;
          await this.saveKnowledge({
            ...this.formData,
          });
          if (this.formData.id) {
            this.$message.success("编辑成功");
          } else {
            this.$message.success("添加成功");
          }
          await this.$router.push(
            {
              name: "DailyClock",
              params: {
                back: true,
              },
            },
            () => {}
          );
        }
      });
    },
  },
};
